import { areObjectsDeeplyEqual } from '../../util/validator';
import { State } from './selector';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} state New state
 * @param {State} oldState Old state
 * @returns {Object} Object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { isLoading, selectedId, routers, disableBooking } = state;
    const hasRoutersChanged = routers && !areObjectsDeeplyEqual(routers, oldState.routers);
    const isSelectedChanged = selectedId !== oldState.selectedId;
    const isDisableBookingChanged = disableBooking !== oldState.disableBooking;

    return {
        loading: isLoading !== oldState.isLoading,
        routerImage: hasRoutersChanged || isSelectedChanged,
        customer: state.customer !== oldState.customer,
        disableBooking: isDisableBookingChanged,
    };
};
